const trackEventMixin = {
  methods: {
    trackEvent (payload) {
      this.$ppAnalytics.trackEvent(payload)
    }
  }
}

export default trackEventMixin
